import { combineEpics } from 'redux-observable';

export const environmentRootEpic = combineEpics();
